import React, { useState, useContext, useEffect } from 'react';
import { useSnackbar, DURATION } from 'baseui/snackbar';
import { Check, Delete } from 'baseui/icon';
import _isEmpty from 'lodash/isEmpty';

import { APPS, MERCHANT_TYPES } from '../../constants';
import { GLOBAL_THEME } from '../../resources';
import { parseJSON, parseString } from '../../utils';
import { UserContext } from '../user';

const ALERT_DURATION: any = {
	SHORT: DURATION.short,
	MEDIUM: DURATION.medium,
	LONG: DURATION.long,
	INFINITE: DURATION.infinite
};

const errorMessageFormatter = (message: string) => {
	let formattedMessage = message.replace(/\d* - {\"error\":\"/, '');
	formattedMessage = formattedMessage.replace(/\"}$/, '');
	formattedMessage = formattedMessage.replace(/\\n/g, '\n');
	return formattedMessage;
};

const alertType = (type: any, size: any) => {
	switch (type) {
		case 'success': {
			return <Check size={size} />;
		}
		case 'error': {
			return <Delete size={size} />;
		}
		default:
			return null;
	}
};

const getDefaultApp = () => {
	const app = parseJSON(localStorage.getItem('app'));
	return _isEmpty(app) ? APPS[0] : app;
};

const useAppProvider = ({ dashboard, userMerchant }: { dashboard: string; userMerchant?: string }) => {
	const defaultApp = getDefaultApp();
	const [app, setApp] = useState(defaultApp);
	const [campaignOptions, setCampaignOptions] = useState<Array<{ id: string; label: string }>>([]);
	const { enqueue } = useSnackbar();
	const { checkIfLoggedIn, getACLUsers } = useContext(UserContext);

	useEffect(() => {
		const getACLUsersAndcheckLogin = async () => {
			if (userMerchant === MERCHANT_TYPES.MARKETING) {
				await getACLUsers();
			}
			await checkIfLoggedIn(dashboard, userMerchant);
		};
		getACLUsersAndcheckLogin();
	}, [dashboard, userMerchant]);

	const showAlert = (
		message: any,
		{ type = 'success', progress = false, duration = 'SHORT', actionMessage, actionOnClick, focus } = {} as {
			type: any;
			progress: any;
			duration: any;
			actionMessage: any;
			actionOnClick: any;
			focus: any;
		}
	) => {
		const formattedMessage = errorMessageFormatter(message);
		return enqueue(
			{
				message: formattedMessage,
				progress,
				actionMessage,
				actionOnClick,
				startEnhancer: ({ size }) => alertType(type, size),
				focus,
				overrides: {
					Root: {
						style: {
							backgroundColor: type === 'success' ? GLOBAL_THEME.Colors.success : GLOBAL_THEME.Colors.error,
							whiteSpace: 'pre-wrap'
						}
					}
				}
			},
			ALERT_DURATION[duration]
		);
	};

	const onAppChange = async (appValue: any) => {
		localStorage.setItem('app', parseString(appValue));
		setApp(appValue);
	};

	return {
		app,
		onAppChange,
		showAlert,
		campaignOptions,
		setCampaignOptions
	};
};

export default useAppProvider;
